'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

import { type SocialIconsPropsT } from '.'

export const SocialIconMainWrapper = styled.div<Pick<SocialIconsPropsT, 'margin'>>`
  ${(props) => props.margin && `margin: ${props.margin}`}
`

export const SITitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: #414a53;

  @media (max-width: 700px) {
    font-size: 18px;
    font-weight: bold;
  }
`

export const SocialIconsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 40px);
  grid-gap: 10px;
  margin: 15px 0;
`

export const SocialIcon = styled.div`
  height: 30px;
  width: 30px;
  position: relative;
  cursor: pointer;
`
